export * from "./PrivacyPolicyPage";
export * from "./TokushohoPage";
export * from "./TermsOfServicePage";
